export const config = {
    "leftBracket": "{{",
    "rightBracket": "}}",
};
